package com.eladfinish.bible.contest.screens.completeVerse.usecases

import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.di.config.DebugInfo
import com.eladfinish.bible.contest.screens.search.model.VerseUiModel

class GetHelpContentUseCase(
    private val assetReader: AssetReader,
    private val debugInfo: DebugInfo,
    private val getAllOptionsToCompleteUseCase: GetAllOptionsToCompleteUseCase,
) {

    operator fun invoke(
        verseRef: String? = null,
        searchResult: VerseUiModel? = null,
        allWords: List<String> = emptyList(),
    ): String = buildString {
        append(assetReader.readFile(fileName = "other${assetReader.fileSeparator}completeVerseGuide.txt"))

        if (debugInfo.isDebugMode && verseRef != null && searchResult != null) {
            append("\n\n")
            append(
                getAllOptionsToCompleteUseCase(
                    searchResult = searchResult,
                    verseRef = verseRef,
                    allWords = allWords,
                )
            )
        }
    }
}
